export type { MaskedInputInterface } from './masked-input';

export { default } from './masked-input';
